import { c as _c } from "react/compiler-runtime";
import { Modal, ModalSizeEnum } from '@systemeio/ui';
import Dmarc, { DMARC_KEY } from 'modules/profile/mailing-settings/components/dmarc';
import DomainVerification from 'modules/profile/mailing-settings/components/domain-verification';
import { DomainId, MailingSettingsDomainDnsSettingsInterface } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface';
import React from 'react';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
interface MailingSettingsDnsSettingsTableInterface extends DataWithPaginationInterface<MailingSettingsDnsItemInterface> {}
export interface MailingSettingsDnsItemInterface {
  id: number;
  key: string;
  value: string;
}
function DnsSettingsModal(t0) {
  const $ = _c(45);
  const {
    dnsSettings,
    opened,
    onClose,
    domainId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== dnsSettings) {
    t1 = Object.values(dnsSettings).map(_temp);
    $[0] = dnsSettings;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const dnsSettingsItems = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      key: DMARC_KEY,
      id: 0,
      value: DMARC_KEY
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== dnsSettingsItems) {
    t3 = {
      items: [...dnsSettingsItems, t2],
      hasMore: false
    };
    $[3] = dnsSettingsItems;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const tableDomainData = t3;
  let t4;
  if ($[5] !== t) {
    t4 = t("dashboard.settings.mailing.dns_settings_modal_dns_record_type_title");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      key: "record-type",
      header: t4,
      widthPercent: 20,
      onRender: _temp2
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("global.name");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = {
      key: "name",
      header: t6,
      widthPercent: 30,
      onRender: _temp3
    };
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("dashboard.settings.mailing.dns_settings_modal_value_title");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== opened) {
    t9 = dns_1 => dns_1.value === DMARC_KEY ? <Dmarc isReady={opened} /> : <div>{dns_1.value}</div>;
    $[15] = opened;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = {
      key: "value",
      header: t8,
      widthPercent: 50,
      onRender: t9
    };
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5 || $[22] !== t7) {
    t11 = [t5, t7, t10];
    $[20] = t10;
    $[21] = t5;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const mailingDnsSettingsColumns = t11;
  let t12;
  if ($[24] !== t) {
    t12 = t("dashboard.settings.mailing.dns_settings_modal_title");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("dashboard.settings.mailing.dns_settings_modal_notice_title");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <div className="flex flex-row gap-4">{t13}</div>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {};
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== mailingDnsSettingsColumns || $[32] !== tableDomainData) {
    t16 = <Table actions={t15} data={tableDomainData} columns={mailingDnsSettingsColumns} />;
    $[31] = mailingDnsSettingsColumns;
    $[32] = tableDomainData;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== domainId) {
    t17 = <DomainVerification domainId={domainId} />;
    $[34] = domainId;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t14 || $[37] !== t16 || $[38] !== t17) {
    t18 = <form className="flex flex-col gap-6 lg:gap-7">{t14}{t16}{t17}</form>;
    $[36] = t14;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== onClose || $[41] !== opened || $[42] !== t12 || $[43] !== t18) {
    t19 = <><Modal opened={opened} onClose={onClose} title={t12} size={ModalSizeEnum.big}>{t18}</Modal></>;
    $[40] = onClose;
    $[41] = opened;
    $[42] = t12;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
}
function _temp3(dns_0) {
  return <div>{dns_0.key}</div>;
}
function _temp2(dns) {
  return dns.key === DMARC_KEY ? <div>TXT</div> : <div>CNAME</div>;
}
function _temp(el, index) {
  return {
    ...el,
    id: index
  };
}
export default DnsSettingsModal;